import { Box, styled, Theme, Typography } from '@mui/material';
import { Alert } from 'sharedComponents/Alert';
import { useTheme } from '@mui/material';

export const PreferencesAlertMessage: React.FC = () => {
  const theme = useTheme();

  return (
    <Alert sx={AlertStyles(theme)} icon={false}>
      <TextContainer>
        <HeadingText>Opt into matching and let the principals come to you!</HeadingText>
        <RegularWeightText>
          Set your preferences, and we’ll match with select principals - for free.
        </RegularWeightText>
        <MediumBoldWeightText> Matching is currently live - don’t miss out!</MediumBoldWeightText>
      </TextContainer>
    </Alert>
  );
};

const TextContainer = styled(Box)(({ theme }) => ({
  gap: theme.spacing(0.5),
  textAlign: 'center',
}));

const HeadingText = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightMediumBold,
  lineHeight: '24px',
  display: 'block',
}));

const MediumBoldWeightText = styled('span')(({ theme }) => ({
  color: theme.palette.info.medium,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightMediumBold,
  lineHeight: '24px',
  display: 'inline',
}));

const RegularWeightText = styled(Typography)(({ theme }) => ({
  color: theme.palette.info.medium,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
  lineHeight: '24px',
  display: 'inline',
}));

const AlertStyles = (theme: Theme) => ({
  borderAlignment: 'inside',
  borderRadius: theme.shape.borderRadius * 0.5,
  padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifySelf: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    height: 'auto',
  },
});
